import type { TEventType } from "@tracking-events/browser";
import {
  VIEW_EVENTS,
  CLICK_EVENTS,
  OPEN_EVENTS,
  CLOSE_EVENTS,
  PURCHASE_EVENTS,
  SUBMIT_EVENTS,
} from "@tracking-events/browser";

import type {
  TClickEvent,
  TEventName,
  TSubmitEvent,
  TViewEvent,
  TOpenEvent,
  TCloseEvent,
  TPurchaseEvent,
} from "./useEvent.map";

export const isClickEvent = (eventName: TEventName): eventName is TClickEvent => (
  CLICK_EVENTS.includes(eventName as TClickEvent)
);

export const isOpenEvent = (eventName: TEventName): eventName is TOpenEvent => (
  OPEN_EVENTS.includes(eventName as TOpenEvent)
);

export const isCloseEvent = (eventName: TEventName): eventName is TCloseEvent => (
  CLOSE_EVENTS.includes(eventName as TCloseEvent)
);

export const isPurchaseEvent = (eventName: TEventName): eventName is TPurchaseEvent => (
  PURCHASE_EVENTS.includes(eventName as TPurchaseEvent)
);

export const isSubmitEvent = (eventName: TEventName): eventName is TSubmitEvent => (
  SUBMIT_EVENTS.includes(eventName as TSubmitEvent)
);

export const isViewEvent = (eventName: TEventName): eventName is TViewEvent => (
  VIEW_EVENTS.includes(eventName as TViewEvent)
);

export const getEventType = (eventName: TEventName): TEventType | undefined => {
  if (isClickEvent(eventName)) { return "click"; }
  if (isCloseEvent(eventName)) { return "close"; }
  if (isOpenEvent(eventName)) { return "open"; }
  if (isViewEvent(eventName)) { return "view"; }
  if (isSubmitEvent(eventName)) { return "submit"; }
  if (isPurchaseEvent(eventName)) { return "purchase"; }
  return undefined;
};

export const createFormLabel = (prefix: string, eventType: TSubmitEvent) => `${prefix}_${eventType}`;
